import React, { useEffect, useState } from "react";
import map from "../../component/assets/map.png";
import { FiEye, FiEyeOff } from "react-icons/fi";
import styles from "./SignIn.module.css";
import { useNavigate } from "react-router-dom";
import LoginModal from "./LoginModal";

export default function SignIn() {
  const [hide, setHide] = useState(true);
  const [mobile, setMobile] = useState("");
  const [active, setActive] = useState("SIGNIN");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(()=>{
setShowModal(true)
  },[])
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "cent`er",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div className={styles.box}>
        <div style={{ position: "relative", marginTop: 80 }}>
          <img src={map} />
          <div
            style={{
              position: "absolute",
              height: 100,
              width: "100%",
              top: 150,
            }}
          >
            <h3
              style={{
                textAlign: "center",
                fontFamily: "initial",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Get Started
            </h3>
            <p style={{ textAlign: "center", fontFamily: "Inter, sans-serif" }}>
              Sign in to access your account
            </p>
          </div>
        </div>

        <div
          style={{
            width: "80%",
            border: "1px solid #66D6FF",
            height: 50,
            borderRadius: 10,
            justifyContent: "space-between",
            display: "flex",
            padding: 5,
          }}
        >
          <button
            style={{
              width: "100%",
              borderRadius: 10,
              border: "none",
              fontFamily: "Inter, sans-serif",
              background: active === "SIGNIN" ? "#66D6FF" : "transparent",
              color: active === "SIGNIN" ? "#fff" : "#07448E",
            }}
            onClick={() => setActive("SIGNIN")}
          >
            SIGN IN / SIGN UP
          </button>
          {/* <button
            style={{
              width: "48%",
              borderRadius: 10,
              border: "none",
              fontFamily: "Inter, sans-serif",
              background: active === "SIGNUP" ? "#66D6FF" : "transparent",
              color: active === "SIGNUP" ? "#fff" : "#07448E",
            }}
            onClick={() => setActive("SIGNUP")}
          >
            SIGN UP
          </button> */}
        </div>
        {active === "SIGNIN" ? (
          <>
            <div style={{ width: "80%", marginTop: 10 }}>
              <p style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
                Mobile Number
              </p>
              <div
                style={{
                  width: "100%",
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your Mobile Number"
                  maxLength={10}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                    if (onlyNums.length <= 10) setMobile(onlyNums);
                  }}
                  value={mobile}
                  style={{ width: "95%", border: "none", outline: "none" }}
                />
              </div>
            </div>
            <br></br>

            <button
              style={{
                width: "80%",
                height: 50,
                borderRadius: 10,
                fontFamily: "Inter, sans-serif",
                border: "none",
                fontWeight: "bold",
                background: "#07448E",
                color: "#fff",
              }}
              onClick={() => navigate("/OTPScreen")}
            >
              SEND OTP
            </button>
          </>
        ) : (
          <>
            <div style={{ width: "80%", marginTop: 30 }}>
              <p style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
                Full Name
              </p>
              <div
                style={{
                  width: "100%",
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your Full Name"
                  style={{ width: "95%", border: "none", outline: "none" }}
                />
              </div>
            </div>

            <div style={{ width: "80%", marginTop: 30 }}>
              <p style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
                Phone
              </p>
              <div
                style={{
                  width: "100%",
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your Phone"
                  style={{ width: "95%", border: "none", outline: "none" }}
                />
              </div>
            </div>

            <div style={{ width: "80%", marginTop: 30 }}>
              <p style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
                Email Id
              </p>
              <div
                style={{
                  width: "100%",
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your email"
                  style={{ width: "95%", border: "none", outline: "none" }}
                />
              </div>
            </div>

            <div style={{ width: "80%", marginTop: 10 }}>
              <p style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
                Password
              </p>
              <div
                style={{
                  width: "100%",
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your Password"
                  type={hide ? "password" : "text"}
                  style={{ width: "87%", border: "none", outline: "none" }}
                />
                {hide ? (
                  <FiEye onClick={() => setHide(false)} />
                ) : (
                  <FiEyeOff onClick={() => setHide(true)} />
                )}
              </div>
              <div style={{ width: "100%", display: "flex", marginTop: 10 }}>
                <input type="checkbox" />
                <p
                  style={{
                    fontSize: 13,
                    fontFamily: "Inter, sans-serif",
                    color: "#07448E",
                    marginLeft: 10,
                    marginTop: 12,
                  }}
                >
                  By checking the box you agree to our{" "}
                  <span style={{ color: "#66D6FF" }}>Terms</span> and{" "}
                  <span style={{ color: "#66D6FF" }}>Conditions.</span>{" "}
                </p>
              </div>
            </div>

            <button
              style={{
                width: "80%",
                height: 50,
                borderRadius: 10,
                fontFamily: "Inter, sans-serif",
                border: "none",
                fontWeight: "bold",
                background: "#07448E",
                color: "#fff",
                marginTop: 13,
              }}
              onClick={() => navigate("/OTPScreen")}
            >
              NEXT
            </button>
          </>
        )}

        <div
          style={{
            width: "60%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              marginTop: 10,
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              color: "#07448E",
            }}
          >
            Other Sign In Options
          </p>
        </div>

        <div
          style={{
            width: "60%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 60,
              height: 60,
              border: "1px solid #D8DADC",
              borderRadius: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="https://cdn.creazilla.com/icons/7911211/facebook-icon-lg.png"
              style={{ width: "50%", height: "50%" }}
            />
          </div>

          <div
            style={{
              width: 60,
              height: 60,
              border: "1px solid #D8DADC",
              borderRadius: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: 10,
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png"
              style={{ width: "50%", height: "50%" }}
            />
          </div>

          <div
            style={{
              width: 60,
              height: 60,
              border: "1px solid #D8DADC",
              borderRadius: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: 10,
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
              style={{ width: "40%", height: "50%" }}
            />
          </div>
        </div>
      </div>
<LoginModal show={showModal} handleClose={() => setShowModal(false)} />
    </div>
  );
}
